export interface QuotationEntity {

    id: number | null,
    consortiumCode: string | null,
    vesselCode: string | null,
    voyageCode: string | null,
    etd: string | null,
    quotationNo: string | null,
    quotationDesc: string | null,
    quotationAmount: number | null,
    activeInd: string | null,
    mappingType: string,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_QUOTATION_ENTITY: QuotationEntity = {
    activeInd: 'Y',
    mappingType: "QuotationEntity",
    id: null,
    consortiumCode: null,
    vesselCode: null,
    voyageCode: null,
    etd: null,
    quotationNo: null,
    quotationDesc: null,
    quotationAmount: null
}
